/**
 * Abstract base class for icon sources.
 */
export abstract class IIconSource {
  /**
   * Retrieves an SVG icon by name.
   * @param name - The icon name without extension
   * @returns The SVG content as a string, or null if not found
   */
  abstract getIcon(name: string): string | null;

  /**
   * Checks if this source contains the specified icon.
   * @param name - The icon name to check
   * @returns True if the icon exists in this source
   */
  abstract hasIcon(name: string): boolean;
}
